import { useInitializeZebelerAuthentication } from './_hooks';
import { PageLoading } from '@/app/ui/page';

const ZebelerAuthentication = ({ children }) => {
  const { isInitialized } = useInitializeZebelerAuthentication();

  if (!isInitialized) {
    return <PageLoading variant="app" />;
  }

  return children;
};

export default ZebelerAuthentication;
